import { async } from "@firebase/util";
import { data } from "autoprefixer";
import axios from "axios";
import toast from "react-hot-toast";

// const URL = `http://localhost:5000`;
const URL = `https://creater-app.herokuapp.com`;

export const signUpUser = async (data) => {
  try {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    return await axios.post(`${URL}/user/signup`, data, config);
  } catch (error) {
    toast.error("signup failed");
    console.log("Error while calling signUpUser API ", error);
  }
};

export const loginUser = async (data) => {
  try {
    let response = await axios.post(`${URL}/user/login`, data);
    return response.data;
  } catch (error) {
    console.log("Error while calling loginUser API ", error);
  }
};

export const signUpCreator = async (data) => {
  try {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    return await axios.post(`${URL}/creator/signup`, data, config);
  } catch (error) {
    toast.error("signup failed");
    console.log("Error while calling signUpCreator API ", error);
  }
};

export const postNew = async (data) => {
  try {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    return await axios.post(`${URL}/creator/post/create`, data, config);
  } catch (error) {
    console.log("Error while calling postNew API ", error);
  }
};

export const buyPost = async (data) => {
  try {
    return await axios.put(`${URL}/user/post/buy`, data);
  } catch (error) {
    console.log("Error while calling buyPost API ", error);
  }
};

export const checkPremium = async (data) => {
  try {
    let response = await axios.post(`${URL}/user/checkpremium`, data);
    if (response.data.message === "user already owns the premium") return true;

    return false;
  } catch (error) {
    console.log("Error while calling checkPremium API ", error);
  }
};

export const loginCreator = async (data) => {
  try {
    let response = await axios.post(`${URL}/creator/login`, data);
    return response.data;
  } catch (error) {
    toast.error("login failed");
    console.log("Error while calling loginCreator API ", error);
  }
};

export const getAllCreators = async () => {
  try {
    let response = await axios.get(`${URL}/creator/`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getAllCreators API ", error);
  }
};

export const getCreatorPosts = async (email) => {
  try {
    let response = await axios.get(`${URL}/creator/posts?email=${email}`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getCreatorPosts API ", error);
  }
};

export const getSpecificCreator = async (email) => {
  try {
    let response = await axios.get(`${URL}/creator/profile/${email}`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getSpecificCreator API ", error);
  }
};

export const getRecharges = async () => {
  try {
    let response = await axios.post(`${URL}/user/recharges`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getRecharges API ", error);
  }
};

export const getSearchedCreators = async (searchString) => {
  try {
    let response = await axios.get(
      `${URL}/creator/search/?search=${searchString}`
    );
    return response.data;
  } catch (error) {
    console.log("Error while calling getSearchedCreators API ", error);
  }
};

export const getAllLiveCreators = async () => {
  try {
    let response = await axios.get(`${URL}/creator/live`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getAllLiveCreators API ", error);
  }
};

export const getPostByCreator = async (data) => {
  try {
    let response = await axios.post(`${URL}/user/posts/creator/`, data);
    console.log(response, "response ");
    return response.data;
  } catch (error) {
    toast.error(error.message);
    console.log("Error while calling getPostByCreator API ", error);
  }
};

export const redeemBalance = async (data) => {
  try {
    let response = await axios.post(`${URL}/creator/redeem`, data);
    return response.data;
  } catch (error) {
    toast.error(error.message);
    console.log("Error while calling redeemBalance API ", error);
  }
};

export const buyPremium = async (data) => {
  try {
    let response = await axios.put(`${URL}/user/subscription/buy`, data);
    return response.data;
  } catch (error) {
    toast.error(error.message);
    console.log("Error while calling buyPremium API ", error);
  }
};

export const getChatToken = async (email) => {
  try {
    let response = await axios.get(`${URL}/common/chattoken/${email}`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getChatToken API ", error);
  }
};

export const getGifts = async (email) => {
  try {
    let response = await axios.get(`${URL}/common/giftlist`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getGifts API ", error);
  }
};

export const getAgoraToken = async (email) => {
  try {
    let response = await axios.get(`${URL}/common/agora/${email}`);
    return response.data;
  } catch (error) {
    console.log("Error while calling getAgoraToken API ", error);
  }
};

export const setCreatorOnline = async (email, room_id) => {
  try {
    let response = await axios.put(`${URL}/creator/online/${email}/${room_id}`);
    return response.data;
  } catch (error) {
    console.log("Error while calling setCreatorOnline API ", error);
  }
};

export const setCreatorOffline = async (email) => {
  try {
    let response = await axios.put(`${URL}/creator/offline/${email}`);
    return response.data;
  } catch (error) {
    console.log("Error while calling setCreatorOnline API ", error);
  }
};

export const createChatRoom = async (user_email, creator_email) => {
  try {
    let response = await axios.get(
      `${URL}/common/createchatroom/${user_email}/${creator_email}`
    );
    return response.data;
  } catch (error) {
    console.log("Error while calling getChatToken API ", error);
  }
};

export const isVerified = async (user_email) => {
  try {
    let response = await axios.get(`${URL}/creator/isverified/${user_email}`);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const addbankDetails = async (data) => {
  try {
    let response = await axios.put(`${URL}/creator/updatedetails`, data);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return true;
  }
};

export const subCountOfCreator = async (creator_email) => {
  try {
    let response = await axios.get(
      `${URL}/user/creator/subcount/${creator_email}`
    );
    if (response.status === 200) {
      return response.data.subcount;
    } else {
      return 0;
    }
  } catch (error) {
    return 0;
  }
};

export const getBio = async (email) => {
  try {
    let response = await axios.get(`${URL}/creator/bio/${email}`);
    if (response.status === 200) {
      return response.data.bio;
    } else {
      return "";
    }
  } catch (error) {
    return "";
  }
};

export const updateBioCreator = async (data) => {
  try {
    let response = await axios.put(`${URL}/creator/updatebio`, data);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const updateCreatorImage = async (email, data) => {
  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  try {
    console.log(data);
    let response = await axios.put(
      `${URL}/creator/update/image/${email}`,
      data,
      config
    );
    console.log(response);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
export const updateCreatorBanner = async (email, data) => {
  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  try {
    console.log(data);
    let response = await axios.put(
      `${URL}/creator/update/banner/${email}`,
      data,
      config
    );
    console.log(response);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const updateUserImage = async (email, data) => {
  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  try {
    console.log(data);
    let response = await axios.put(
      `${URL}/user/update/image/${email}`,
      data,
      config
    );
    console.log(response);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
export const updateUserBanner = async (email, data) => {
  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  try {
    console.log(data);
    let response = await axios.put(
      `${URL}/user/update/banner/${email}`,
      data,
      config
    );
    console.log(response);
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const getUserByEmail = async(email) => {
  try {
    console.log(data);
    let response = await axios.get(
      `${URL}/user/${email}`,
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}
